// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-heading.card-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.title-section {
  display: flex;
  align-items: center;
}

.title-icon {
  margin-right: 10px;
  color: #ed6c02;
}

.card-menus {
  display: flex;
  gap: 10px;
}

.btn-compose {
  background-color: #ed6c02;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-compose:hover {
  background-color: #d45a00;
  color: white;
}

.panel-body {
  padding: 15px;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}

.table th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
}

.required {
  color: #dc3545;
}

.modal-title {
  margin: 0;
  color: #333;
}

.btn-cancel {
  background-color: #6c757d;
  color: white;
  border: none;
}

.btn-cancel:hover {
  background-color: #5a6268;
  color: white;
}

.btn-primary {
  background-color: #ed6c02;
  border-color: #ed6c02;
}

.btn-primary:hover {
  background-color: #d45a00;
  border-color: #d45a00;
}

.form-control:focus {
  border-color: #ed6c02;
  box-shadow: 0 0 0 0.2rem rgba(237, 108, 2, 0.25);
}

/* Card Count Styles */
.card-count {
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-count.primary {
  background-color: #ed6c02;
  color: white;
}

.card-count.success {
  background-color: #28a745;
  color: white;
}

.card-count.danger {
  background-color: #dc3545;
  color: white;
}

.card-count-icon {
  font-size: 2rem;
  margin-bottom: 10px;
}

.card-count-title {
  font-size: 1rem;
  margin-bottom: 5px;
}

.card-count-value {
  font-size: 1.5rem;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/App/components/Loan/admin/LoanProducts/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".panel-heading.card-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n}\n\n.title-section {\n  display: flex;\n  align-items: center;\n}\n\n.title-icon {\n  margin-right: 10px;\n  color: #ed6c02;\n}\n\n.card-menus {\n  display: flex;\n  gap: 10px;\n}\n\n.btn-compose {\n  background-color: #ed6c02;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-compose:hover {\n  background-color: #d45a00;\n  color: white;\n}\n\n.panel-body {\n  padding: 15px;\n}\n\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  background-color: transparent;\n}\n\n.table th {\n  background-color: #f8f9fa;\n  border-bottom: 2px solid #dee2e6;\n}\n\n.required {\n  color: #dc3545;\n}\n\n.modal-title {\n  margin: 0;\n  color: #333;\n}\n\n.btn-cancel {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n}\n\n.btn-cancel:hover {\n  background-color: #5a6268;\n  color: white;\n}\n\n.btn-primary {\n  background-color: #ed6c02;\n  border-color: #ed6c02;\n}\n\n.btn-primary:hover {\n  background-color: #d45a00;\n  border-color: #d45a00;\n}\n\n.form-control:focus {\n  border-color: #ed6c02;\n  box-shadow: 0 0 0 0.2rem rgba(237, 108, 2, 0.25);\n}\n\n/* Card Count Styles */\n.card-count {\n  padding: 20px;\n  border-radius: 4px;\n  margin-bottom: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.card-count.primary {\n  background-color: #ed6c02;\n  color: white;\n}\n\n.card-count.success {\n  background-color: #28a745;\n  color: white;\n}\n\n.card-count.danger {\n  background-color: #dc3545;\n  color: white;\n}\n\n.card-count-icon {\n  font-size: 2rem;\n  margin-bottom: 10px;\n}\n\n.card-count-title {\n  font-size: 1rem;\n  margin-bottom: 5px;\n}\n\n.card-count-value {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
